module.exports = __webpack_public_path__ + "static/img/bg_7.d48f0b4.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/bg_7.png
// module id = 780
// module chunks = 1